import { render, staticRenderFns } from "./EnacCustomAtplAssessmentEdit.vue?vue&type=template&id=2a8a0aaf"
import script from "./EnacCustomAtplAssessmentEdit.vue?vue&type=script&lang=js"
export * from "./EnacCustomAtplAssessmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports